import { flatMap } from 'remeda';

/**
 * console.log(intersperse(() => "x", [1, 2, 3]));
 * -> [1, 'x', 2, 'x', 3]
 */
export default function intersperseWith<I, T>(
  separator: (idx: number) => I,
  list: T[],
): (T | I)[] {
  return flatMap(list, (item, index) =>
    index < list.length - 1 ? [item, separator(index * 2 - 1)] : [item],
  );
}

/**
 * console.log(intersperse(() => "x", [1, 2, 3]));
 * -> [1, 'x', 2, 'x', 3]
 */
export function intersperse<I, T>(separator: I, list: T[]): (T | I)[] {
  return flatMap(list, (item, index) =>
    index < list.length - 1 ? [item, separator] : [item],
  );
}
